"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseDriver = exports.SQLDriverWithDataMapping = exports.DatabaseIntegration = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The database integrations
 */
exports.DatabaseIntegration = (0, type_utils_1.makeEnum)({
    postgresql: 'postgresql',
    redshift: 'amazonredshift',
    snowflake: 'snowflake',
    mysql: 'mysql',
    bigquery: 'bigquery',
    microsoftsql: 'microsoftsql',
    maria: 'maria',
    mongodb: 'mongodb',
    amazondynamodb: 'amazondynamodb',
    amazons3: 'amazons3',
    databrickslakehouse: 'databrickslakehouse',
    ibmdb2: 'ibmdb2',
    oracle: 'oracle',
    quickbase: 'quickbase',
    redis: 'redis',
    treasuredata: 'treasuredata',
    saps4hana: 'saps4hana',
});
/**
 * The possible drivers for a database integration
 */
exports.SQLDriverWithDataMapping = (0, type_utils_1.makeEnum)({
    [exports.DatabaseIntegration.redshift]: 'Amazon Redshift',
    [exports.DatabaseIntegration.postgresql]: 'PostgreSQL Unicode',
    [exports.DatabaseIntegration.snowflake]: 'SnowflakeDSIIDriver',
    [exports.DatabaseIntegration.mysql]: 'MySQL',
    [exports.DatabaseIntegration.bigquery]: 'Google BigQuery',
    [exports.DatabaseIntegration.microsoftsql]: 'Microsoft SQL',
    [exports.DatabaseIntegration.maria]: 'MariaDB',
    [exports.DatabaseIntegration.databrickslakehouse]: 'Databricks Lakehouse',
    [exports.DatabaseIntegration.ibmdb2]: 'IBM DB2',
    [exports.DatabaseIntegration.oracle]: 'Oracle DB',
});
/**
 * All possible drivers for a database integration, regardless
 * or not they support data mapping
 */
exports.DatabaseDriver = (0, type_utils_1.makeEnum)({
    ...exports.SQLDriverWithDataMapping,
    [exports.DatabaseIntegration.mongodb]: 'MongoDB',
    [exports.DatabaseIntegration.amazondynamodb]: 'AmazonDynamoDB',
    [exports.DatabaseIntegration.amazons3]: 'AmazonS3',
    [exports.DatabaseIntegration.databrickslakehouse]: 'Databricks Lakehouse',
    [exports.DatabaseIntegration.quickbase]: 'Quickbase',
    [exports.DatabaseIntegration.redis]: 'Redis',
    [exports.DatabaseIntegration.treasuredata]: 'TreasureData',
    [exports.DatabaseIntegration.saps4hana]: 'SapS4Hana',
});
//# sourceMappingURL=database.js.map